import { PLAN_TYPE } from "@/constants";
import { FEATURE, FeatureType } from "@/features";
import { useOrganization } from "@/hooks/useOrganization";
import useSearchParams from "@/hooks/useSearchParams";

import BasicPlanModal from "./BasicPlanModal";
import CustomPlanModal from "./CustomPlanModal";

const customFeatures: FeatureType[] = [
  FEATURE.HAS_SEARCH_PRODUCT,
  FEATURE.HAS_REPORT_PRODUCT,
];
const UpsaleModals = () => {
  const { data: orgData } = useOrganization();
  const plan = orgData?.ok ? orgData.data.plan : null;
  const [{ upsale }, setParams] = useSearchParams<{ upsale?: FeatureType }>();

  const onHide = () => {
    setParams({ upsale: undefined });
  };

  if (
    customFeatures.includes(upsale as FeatureType) ||
    plan?.type === PLAN_TYPE.BASIC
  ) {
    return <CustomPlanModal onHide={onHide} show={Boolean(upsale)} />;
  }

  return <BasicPlanModal onHide={onHide} show={Boolean(upsale)} />;
};

export default UpsaleModals;
